import { useQuery } from "@tanstack/react-query";
import { request } from "@/utils";
import { getEntityModelParam } from "@/utils/entityModel";
import type { IPaginatedData } from "@/types/api/paginate";

export interface ISearchProduct {
  _type: "product";
  id: string;
  slug: string;
  name: string;
  short_description: string | null;
  price: string;
  sale_price: string | null;
  primary_image: string;
  category: {
    id: string;
    slug: string;
    name: string;
  };
  similarity_score: number;
}

interface UseHomeSearchParams {
  query?: string;
  enabled?: boolean;
}

export const useHomeSearch = ({ query, enabled = true }: UseHomeSearchParams) => {
  return useQuery({
    queryKey: ["home-search", { query }],
    queryFn: async () => {
      const response = await request<{ data: ISearchProduct[]; meta: any }>({
        url: "v1/search",
        method: "GET",
        params: {
          ...getEntityModelParam(),
          q: query || undefined,
        },
      });
      return response.data || [];
    },
    enabled: enabled && !!query && query.trim().length > 0,
    staleTime: 5 * 60 * 1000,
  });
};
